import { useMutation, useQueryClient } from '@tanstack/react-query';
import { confirmDialog } from 'primereact/confirmdialog';
import { useTranslation } from 'react-i18next';
import { disconnectCloudflare } from '../../../services/bot-sources/CloudflareIntegrationService';
import { CLOUDFLARE_STATUS } from '../../query/bot-sources/keys';
import {
  GET_BOTS_ACTIVITY_CONTENT,
  GET_BOTS_ACTIVITY_OVERVIEW,
  GET_BOTS_ACTIVITY_STATUS,
  GET_BOTS_ACTIVITY_TIMESERIES,
} from '../../query/bots-activity/keys';

export const useDisconnectCloudflare = (projectId: number, integrationId: number | null) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const mutation = useMutation<void, Error, void>({
    mutationFn: () => {
      if (!integrationId) throw new Error('No active integration to disconnect');
      return disconnectCloudflare(projectId, integrationId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CLOUDFLARE_STATUS, projectId] });
      queryClient.invalidateQueries({ queryKey: [GET_BOTS_ACTIVITY_OVERVIEW, projectId] });
      queryClient.invalidateQueries({ queryKey: [GET_BOTS_ACTIVITY_TIMESERIES, projectId] });
      queryClient.invalidateQueries({ queryKey: [GET_BOTS_ACTIVITY_CONTENT, projectId] });
      queryClient.invalidateQueries({ queryKey: [GET_BOTS_ACTIVITY_STATUS, projectId] });
    },
  });

  const disconnectWithConfirm = (onSuccess?: () => void) => {
    confirmDialog({
      message: t('botsActivity.disconnectConfirmMessage'),
      header: t('botsActivity.disconnectConfirmHeader'),
      defaultFocus: 'reject',
      accept: () => {
        mutation.mutate(undefined, { onSuccess });
      },
    });
  };

  return {
    disconnectWithConfirm,
    isPending: mutation.isPending,
    isError: mutation.isError,
  };
};
